import Link from 'next/link';

import { TextArticle } from '@/components/TextArticle';
import { EntityListArticleItem } from '@/shared/api/__generated__/models';
import { Text } from '@/shared/ui';
import styles from './Article.module.css';

interface ArticleProps {
  url?: string;
  title: string;
  articles: EntityListArticleItem[];
}

export const Article = ({ url, title, articles }: ArticleProps) => {
  return (
    <div className={styles.root}>
      {url ? (
        <Link href={url}>
          <div className={styles.wrapper}>
            <Text
              className={styles.title}
              color="white"
              fontSize={22}
              fontWeight={700}
              lineHeight={22}
              letterSpacing={-0.22}
              variant="tertiary"
            >
              {title}
            </Text>
          </div>
        </Link>
      ) : (
        <div className={styles.wrapper}>
          <Text
            className={styles.title}
            color="white"
            fontSize={22}
            fontWeight={700}
            lineHeight={22}
            letterSpacing={-0.22}
            variant="tertiary"
          >
            {title}
          </Text>
        </div>
      )}
      <div>
        {articles.map((article, idx) => (
          <TextArticle
            article={article}
            slots={{
              titleProps: {
                color: 'white',
                fontSize: 14,
                fontWeight: 575,
                lineHeight: '140%',
                letterSpacing: 0.028,
              },
              dateProps: { color: 'neutral-1-70' },
            }}
            key={idx}
          />
        ))}
      </div>
    </div>
  );
};
